import { client } from '@/common-utils/libraries/axios/axios';
import DOCUMENTATION from '../apiUrls';
import DOCUMENTATION_FIELDS from '../../fields/DocumentationFields';

const mapResponseData = (responseData) => {
    const data = {
        [DOCUMENTATION_FIELDS.URL.key]: responseData[DOCUMENTATION_FIELDS.URL.key]
    };

    return data;
};

const queryGetPayluddInitGuideDocumentation = (enabled = true) => {
    return {
        queryKey: [DOCUMENTATION.PAYLUDD_INIT_GUIDE.queryKey],
        queryFn: async () => {
            const response = await client.get(DOCUMENTATION.PAYLUDD_INIT_GUIDE.url);
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetPayluddInitGuideDocumentation;